import { differenceInDays } from 'date-fns';

import type {
  CommunicationDetails,
  CommunicationsDetailsCitizen,
  CommunicationsDetailsStudy,
} from '@izimi/api';
import { convertLocalDateToUTCDate } from '@izimi/utils';

import { _collection } from '../../common';

const EXPIRATION_DAYS = 60;

/**
 * @deprecated Entity classes are being removed. Use the generated `BoxCommunicationDetails`
 * type from `@fednot/certinot-api` together with the helpers in `communications/helpers.ts`.
 */
abstract class BaseCommunicationDetailsEntity {
  readonly id: string;
  readonly title: string;
  readonly message: string;
  readonly creationDate: string;
  readonly lastModificationDate: string;
  readonly expirationDate: string;
  readonly isSeenReceiver: boolean;
  readonly isSeenSender: boolean;
  readonly sender: CommunicationsDetailsStudy;
  readonly receiver: CommunicationsDetailsCitizen;

  readonly [_collection]?: string;

  constructor(communicationDetails: CommunicationDetails, collection?: string) {
    Object.assign(this, communicationDetails);
    this[_collection] = collection;
  }

  private calculateDays(date: string) {
    const now = convertLocalDateToUTCDate(new Date());
    const scheduledDate = convertLocalDateToUTCDate(new Date(date));
    const difference = differenceInDays(scheduledDate, now);
    return difference <= 0 ? 1 : difference;
  }

  get isSeen() {
    return this.isSeenReceiver;
  }

  get remainingDays() {
    return this.calculateDays(this.expirationDate);
  }

  get isExpiringSoon() {
    if (this.remainingDays == null) return false;
    return this.remainingDays < EXPIRATION_DAYS;
  }
}

export default BaseCommunicationDetailsEntity;
